<template>
  <div class="animated fadeIn">
    <!-- Modal Component -->
    <b-modal
      ref="deleteModal"
      hide-footer
      title="신청서 삭제"
    >
      <p class="my-4">
        신청서를 삭제하겠습니까?
      </p>
      <b-button
        variant="outline-danger"
        block
        @click="deleteApplyForm()"
      >
        삭제(Delete)
      </b-button>
      <b-button
        variant="outline-primary"
        block
        @click="$refs.deleteModal.hide()"
      >
        취소(Cancel)
      </b-button>
    </b-modal>
    <!-- 이제부터 신청 정보 -->
    <b-row
      align-h="start"
    >
      <b-col
        md="10"
        class="text-left"
      >
        <h4>
          {{ !userEnabled ? '장학금 신청을 위해 정보를 입력해주세요' : '장학금 신청서 제출 완료' }}
          <b-badge
            v-show="userEnabled"
            variant="primary"
          >
            {{ schlsType === 'DONATED' ? '지정기탁' : schlsType }}
          </b-badge>
          <b-badge :variant="userEnabled ? 'success' : 'danger'">
            {{ userEnabled ? '신청완료' : '신청안함' }}
          </b-badge>
        </h4>
      </b-col>
      <b-col
        v-show="(!noEdit && (freezing && certFreezing))"
        md="2"
        class="text-right"
      >
        <b-button
          class="mb-5"
          variant="warning"
          size="md"
          @click="setFreezing(false)"
        >
          <b>수정하기</b>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-if="!freezing"
        md="12"
      >
        <b-form-group>
          <b-form-radio-group
            id="radios2"
            v-model="schlsType"
            name="radioSubComponent"
          >
            <b-form-radio
              value="TOP"
              selected
            >
              Top
            </b-form-radio>
            <b-form-radio value="DONATED">
              지정기탁(Donated)
            </b-form-radio>
            <b-form-radio
              value="SUMMIT"
              disabled
            >
              {{ part === '초등56부' ? '초등부는 Summit 장학금이 없습니다' : 'Summit(성적표 제출시 자동으로 선택됩니다 | automatically selected, when certificates submitted)' }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 각 부서별 안내사항 -->
    <b-row v-if="part === '해외유학부'">
      <b-col
        md="12"
        class="mb-2"
      >
        <b-list-group>
          <b-list-group-item variant="danger">
            해외유학생은 출석확인서를 "<b>[attendance]_이름.pdf</b>" 이름으로 꼭 제출해주세요
            <a :href="serverUri + '/cdn/data?id=attendance'">
              <b-button
                variant="success"
                size="sm"
              >
                양식받기
              </b-button>
            </a>
            <br>
            해외유학생은 성적표 제출시 설명을 꼭 함께 제출해주세요
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <!-- TODO admin - 매칭 정보 세팅 -->
    <!-- 학교 정보 -->
    <b-row>
      <b-col md="2">
        <b-form-group
          name="part"
          label="부서"
          label-for="part"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-select
            v-model="part"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            :options="partOptions"
            name="part"
            :state="isValid('part')"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          name="schoolSet"
          label="학교"
          label-for="school"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="school"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            name="school"
            placeholder="학교명(school/univ.)"
            :state="isValid('school')"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          name="majorSet"
          label="전공"
          label-for="major"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="major"
            :disabled="freezing"
            name="major"
            placeholder="전공(depart/major)"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          name="gradeSet"
          label="학년"
          label-for="grade"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="grade"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            name="grade"
            :state="isValid('grade')"
            placeholder="학년(grade)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <apply-any
      :name="'works'"
      :email="email"
      :apply-id="applyId"
      :title="'현재 내가 누리고 있는 말씀의 흐름과 그에 대한 나만의 작품(형식자유) 제출.(Submit the flow of the Word you are currently enjoying and your masterpiece(any type) about it.)'"
      placeholder="Top: 옵션(optional) / Summit&연속수여: 필수(required)"
      :read-only="freezing"
      @updateFileAll="updateWorkAll"
    />
    <apply-cert
      :email="email"
      :apply-id="applyId"
      :read-only="certFreezing || part === '초등56부'"
      :schls-type="schlsType"
      @updateCertAll="updateCertAll"
    />
    <!-- 훈련 정도 불러와서 readonly -->
    <!-- 현재 하고 있는 헌신 -->
    <b-row>
      <b-col md="12">
        <hr>
        <b-form-group
          name="devotionSet"
          label="현재 교회에 헌신하는 활동을 작성해주세요"
          label-for="devotion"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="devotion"
            :disabled="freezing"
            name="devotion"
            placeholder="Please write your current devotion for our church)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 계좌 정보 -->
    <b-row>
      <b-col md="4">
        <b-form-group
          name="bankSet"
          label="은행"
          label-for="bank"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="bank"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            name="bank"
            :state="isValid('bank')"
            placeholder="은행(bank)"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          name="accountSet"
          label="계좌번호"
          label-for="account"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="account"
            v-validate.initial="veeNumber"
            :disabled="freezing"
            name="account"
            :state="isValid('account')"
            placeholder="숫자만 입력(bank account only numbers)"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          name="accountHolderSet"
          label="계좌주"
          label-for="accountHolder"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="accountHolder"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            name="accountHolder"
            :state="isValid('accountHolder')"
            placeholder="예금주 입력(Bank Account Holder)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 기도후원자 -->
    <b-row>
      <b-col md="12">
        <b-form-group
          name="pSupporter"
          label="기도후원자(나의 기도 후원자 또는 영적멘토를 공유해주세요)"
          label-for="pSupporter"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="pSupporter"
            v-validate.initial="veeRequired"
            :disabled="freezing"
            name="pSupporter"
            :state="isValid('pSupporter')"
            placeholder="기도후원자(My prayer supporter)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- TOPIC1 -->
    <b-row>
      <b-col md="12">
        <b-form-group
          name="topic1Set"
          :label="nameForTopic1"
          label-for="topic1"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-textarea
            id="topic1"
            v-model="topic1"
            :disabled="freezing"
            :placeholder="'성의 있게 작성해주세요(' + String(lenLimitTopic1) + '자 초과)'"
            :rows="10"
            :max-rows="freezing ? 1000 : 10"
            :state="topic1.length === 0 ? null : (topic1.length > lenLimitTopic1)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- TOPIC2 -->
    <b-row>
      <b-col md="12">
        <b-form-group
          name="topic2Set"
          :label="nameForTopic2"
          label-for="topic2"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-textarea
            id="topic2"
            v-model="topic2"
            :disabled="freezing"
            :placeholder="'성의 있게 작성해주세요(' + String(lenLimitTopic2) + '자 초과)'"
            :rows="10"
            :max-rows="freezing ? 1000 : 10"
            :state="topic2.length === 0 ? null : (topic2.length > lenLimitTopic2)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 인턴십 지원 여부 -->
    <b-row>
      <b-col md="4">
        <b-form-group
          name="itsSet"
          label="인턴십 신청(Request for Intership)"
          label-for="its"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-select
            v-model="its"
            :disabled="freezing"
            :options="itsOptions"
            name="its"
          />
        </b-form-group>
      </b-col>
      <b-col md="8">
        <b-form-group
          name="itsDetailSet"
          label="인턴십 요청사항"
          label-for="itsDetail"
          :invalid-feedback="''"
          :valid-feedback="''"
        >
          <b-form-input
            v-model="itsDetail"
            :disabled="freezing"
            name="itsDetail"
            :readonly="isNoIts"
            placeholder="인턴십 요청사항(any request related to the internship)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!freezing || !certFreezing">
      <b-col
        v-if="userEnabled && !freezing"
        :md="6"
        class="text-center"
      >
        <b-button
          class="mb-5"
          variant="danger"
          @click="$refs.deleteModal.show()"
        >
          삭제(Remove)
        </b-button>
      </b-col>
      <b-col
        :md="userEnabled ? 6 : 12"
        class="text-center"
      >
        <b-button
          :disabled="freezing && certFreezing"
          class="mb-5"
          variant="success"
          block
          @click="validateUpdateDetailInfo()"
        >
          <strong>제출(Submit)</strong>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'
import ApplyCert from './ApplyCert'
import ApplyAny from './ApplyAnyFile'

export default {
  name: 'ApplyInfo',
  components: { ApplyCert, ApplyAny },
  props: {
    email: {
      type: String,
      required: true
    },
    applyId: {
      type: String,
      required: true
    },
    lock: {
      type: Boolean,
      default: false
    },
    summitLock: {
      type: Boolean,
      default: false
    },
    initialReadOnly: {
      type: Boolean,
      required: true
    },
    noEdit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      its: api.ITSDETAIL[0],
      itsOptions: api.ITSDETAIL,
      itsDetail: '',
      topic1: '',
      serverUri: api.serverURI,
      topic2: '',
      bank: '',
      pSupporter: '',
      account: '',
      accountHolder: '',
      devotion: '',
      grade: '',
      major: '',
      school: '',
      part: '',
      partOptions: api.PARTLIST,
      schlsType: 'TOP',
      veeNumber: {
        required: true,
        regex: /^(\d+)$/
      },
      veeRequired: {
        required: true
      },
      pdfCertAll: [],
      workAll: [],
      isReadOnly: this.initialReadOnly,
      userEnabled: false
    }
  },
  computed: {
    nameForTopic1 () {
      return api.nameTopic1(this.applyId.substring(0, 8)) + `(${this.topic1.length}자/${this.lenLimitTopic1}자)`
    },
    nameForTopic2 () {
      return api.nameTopic2(this.applyId.substring(0, 8)) + `(${this.topic2.length}자/${this.lenLimitTopic2}자)`
    },
    freezing () {
      return (this.lock || this.isReadOnly)
    },
    certFreezing () {
      return (this.summitLock || this.isReadOnly)
    },
    isNoIts () {
      return this.its === this.itsOptions[0]
    },
    lenLimitTopic1 () {
      if (this.part === '대학부' || this.part === '고등부') {
        return 1000
      } else if (this.part === '중등부' || this.part === '해외유학부') {
        return 500
      }
      return 0
    },
    lenLimitTopic2 () {
      if (this.part === '대학부' || this.part === '고등부') {
        return 1000
      } else if (this.part === '중등부' || this.part === '해외유학부') {
        return 500
      }
      return 0
    }
  },
  watch: {
    part: function (newVal) {
      if (newVal === '초등56부') {
        this.schlsType = 'TOP'
      }
    }
  },
  mounted () {
    this.getApplyForm()
  },
  methods: {
    isValid (name) {
      if (this.$validator.flags[name] === undefined) {
        return null
      } else if (!this.$validator.flags[name].validated) {
        return null
      } else {
        return this.$validator.flags[name].valid
      }
    },
    setFreezing (val) {
      this.isReadOnly = val
    },
    deleteApplyForm () {
      api.request('delete', '/apply/delete?applyId=' + api.docId('apply', this.email))
        .then(response => {
          var data = response.data
          this.$store.commit('setSubmit', 0)
          alert(data.msg)
          this.$router.go()
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    },
    getApplyForm () {
      this.$validator.reset()
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('get', '/apply/check?applyId=' + this.applyId + '&info=1&ic=all')
        .then(response => {
          var data = response.data
          if (data.check === 0) {
            this.setFreezing(false)
          } else {
            this.userEnabled = true
            this.parseApply(data)
            this.setFreezing(true)
            this.$validator.reset()
          }
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    },
    parseApply (data) {
      this.schlsType = data.schlsType
      this.part = data.part
      this.school = data.school
      this.major = data.major
      this.grade = data.grade
      this.devotion = data.devotion
      this.bank = data.bank
      this.pSupporter = data.pSupporter
      this.account = data.account
      this.accountHolder = data.accountHolder
      this.topic1 = data.topic1
      this.topic2 = data.topic2
      this.its = api.ITSDETAIL[data.its]
      this.itsDetail = data.itsDetail
    },
    updateCertAll (certs, toTop) {
      this.pdfCertAll = certs
      let catched = false
      this.pdfCertAll.forEach(pdf => {
        if (!pdf.name.includes('[attendance]')) {
          this.schlsType = 'SUMMIT'
          catched = true
        }
      })
      if (!catched && toTop) {
        this.schlsType = 'TOP'
      }
    },
    updateWorkAll (certs) {
      this.workAll = certs
    },
    alertSuccess () {
      this.setFreezing(true)
      this.$validator.reset()
      alert('등록이 완료되었습니다.')
      this.$router.push('/dashboard')
    },
    alertFail (msg) {
      alert(msg)
    },
    alertRetry () {
      alert('빨간색으로 표시된 상자를 확인해주세요.(Check all the red boxes)')
    },
    validateUpdateDetailInfo () {
      this.$validator.validate()
        .then(valid => {
          this.updateDetailInfo(valid)
        })
    },
    updateDetailInfo (valid) {
      // 보정
      this.topic1 = this.topic1.replace(/\n{2,}/gi, '\n')
      this.topic2 = this.topic2.replace(/\n{2,}/gi, '\n')
      this.topic1 = this.topic1.replace(/\s{2,}/gi, ' ')
      this.topic2 = this.topic2.replace(/\s{2,}/gi, ' ')
      if (!valid) {
        // 제대로 확인 하라고 에러 메시지
        this.alertRetry()
        return
      }
      if (this.topic1.length <= this.lenLimitTopic1) {
        alert('주제1은 ' + String(this.lenLimitTopic1) + '자 초과 작성해주세요(Topic1 must be grater than ' + String(this.lenLimitTopic1) + 'characters)')
        return
      }
      if (this.topic2.length <= this.lenLimitTopic2) {
        alert('주제2는 ' + String(this.lenLimitTopic2) + '자 초과 작성해주세요(Topic2 must be greater than ' + String(this.lenLimitTopic2) + 'characters)')
        return
      }
      if (this.schlsType === 'SUMMIT' && this.workAll.length === 0) {
        alert('summit은 반드시 작품을 제출해야 합니다(Your masterpiece is required for summit scholarship)')
        return
      }
      // post arg 세팅
      var postArg = {}
      postArg['applyId'] = this.applyId
      postArg['schlsType'] = this.schlsType
      postArg['part'] = this.part
      postArg['school'] = this.school
      postArg['major'] = this.major
      postArg['grade'] = this.grade
      postArg['devotion'] = this.devotion
      postArg['bank'] = this.bank
      postArg['pSupporter'] = this.pSupporter
      postArg['account'] = this.account
      postArg['accountHolder'] = this.accountHolder
      postArg['topic1'] = this.topic1
      postArg['topic2'] = this.topic2
      postArg['its'] = Number(this.its.split('.')[0]) - 1
      postArg['itsDetail'] = this.itsDetail
      postArg['certs'] = this.pdfCertAll
      postArg['works'] = this.workAll
      postArg['email'] = this.email
      postArg['modifiedDate'] = api.currentUnixTime()

      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('post', '/apply/regist', postArg)
        .then(response => {
          var data = response.data
          /* 200 이면  data에 바로 doc정보가 있거나, data.error가 있음
             400 이면 erros.response.data.error */
          if (data.error) {
            this.alertFail(data.error)
          } else {
            this.$store.commit('setSubmit', 1)
            this.alertSuccess()
          }
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    }
  }
}
</script>

<style>
</style>
